import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import MessageComposeAdapter from '../../adapters/MessageComposeAdapter';
import { ApiMethodCallback } from '../ApiMethod';
import { createErrorResult, createSuccessResult } from '../ApiMethodResponseCreator';
import { EmailAddressDetails } from '../getInitialData/EmailAddressDetails';
import { getAdapter } from '../../adapters/AdapterManager';

export default function getFromAsyncApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: any,
    callback: ApiMethodCallback
) {
    const adapter: MessageComposeAdapter = getAdapter(hostItemIndex) as MessageComposeAdapter;
    const from: EmailAddressWrapper = adapter.getFrom();
    if (!from) {
        callback(createErrorResult());
        return;
    }
    const details: EmailAddressDetails = { name: from.Name, address: from.EmailAddress };
    callback(createSuccessResult(details));
}
